import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

import { ApplicationDto } from './ApplicationApi';

export interface ValidationIdDocumentRequest {
  applicationId: string;
  borrowerType: string;
  frontImage: string;
  backImage?: string | null;
  faceImage?: string;
  trackString?: string;
  documentType: DiveDocumentTypes;
}

export interface GenerateValidationSessionRequest {
  applicationId: string;
  borrowerType: string;
  documentType: DiveDocumentTypes;
}

export interface GenerateValidationSessionDto {
  sessionId: string;
}

export interface GetValidationSessionRequest {
  sessionId: string;
}

export interface GetValidationSessionDto {
  sessionId: string;
  documentType: DiveDocumentTypes;
}

export interface ValidationIdDocumentBySessionRequest {
  sessionId: string;
  frontImage: string;
  backImage?: string | null;
  faceImage?: string;
  documentType: DiveDocumentTypes;
  trackString?: string;
}

export enum DiveDocumentTypes {
  ID = 1,
  Passport = 2,
  PassportCard = 3,
  GreenCard = 6,
  InternationalId = 7,
}

export default class ValidationIdApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/identity' || '');
  }

  public async validateDocuments(body: ValidationIdDocumentRequest): Promise<ApplicationDto> {
    return this.instance.post('/validate-document', body).then((response: AxiosResponse<any>) => response.data);
  }

  public async validateDocumentsBySession(body: ValidationIdDocumentBySessionRequest): Promise<boolean> {
    return this.instance
      .post('/validate-document-by-session', body)
      .then((response: AxiosResponse<any>) => response.data);
  }

  public async generateValidationSession(
    body: GenerateValidationSessionRequest,
  ): Promise<GenerateValidationSessionDto> {
    return this.instance.post('/generate-session', body).then((response: AxiosResponse<any>) => response.data);
  }

  public async getValidationSession({ sessionId }: GetValidationSessionRequest): Promise<GetValidationSessionDto> {
    const params = new URLSearchParams();

    params.append('sessionId', sessionId);

    return this.instance.get('/session', { params: params }).then((response: AxiosResponse<any>) => response.data);
  }
}

export const validationIdApi = new ValidationIdApi();
